module.exports = __webpack_public_path__ + "static/homepage-2-5-ed08879732a9b43cec583f7f69f5388b.png";